module.exports = __webpack_public_path__ + "img/item_image_2.8d0c1150.jpg";